import React from 'react';
import { Spinner } from "@material-tailwind/react";

type LoadingOverlayProps = {
  isVisible: boolean
  isFixed?: boolean
}

const LoadingOverlay = ({ isVisible, isFixed = true }: LoadingOverlayProps) => {
  return (
    <div className={`${isFixed ? 'fixed h-screen w-screen inset-0' : 'absolute h-full w-full top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'} bg-gray-800 bg-opacity-70 flex items-center justify-center transition duration-300 ${isVisible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
			<Spinner width={80} height={80} />
		</div>
	);
}

export default LoadingOverlay;